module.exports = __webpack_public_path__ + "SimbramDas-06df8f5b.webp";